var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-4 toolbar-card", attrs: { elevation: "1" } },
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            { attrs: { align: "center" } },
            [
              !_vm.isEditingName
                ? _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "span",
                        { staticClass: "text-body-2 font-weight-medium" },
                        [_vm._v(_vm._s(_vm.$t("floor_plan_label")) + ":")]
                      ),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "ml-2 d-inline-block compact-select",
                        staticStyle: { width: "200px" },
                        attrs: {
                          value: _vm.currentFloorPlan.id,
                          items: _vm.floorPlanOptions,
                          "item-text": "name",
                          "item-value": "id",
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                        },
                        on: { change: _vm.handleFloorPlanChange },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditingName
                ? _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "span",
                        { staticClass: "text-body-2 font-weight-medium" },
                        [_vm._v(_vm._s(_vm.$t("floor_plan_label")) + ":")]
                      ),
                      _vm._v(" "),
                      _c("v-text-field", {
                        staticClass: "ml-2 d-inline-block",
                        staticStyle: { width: "200px" },
                        attrs: {
                          "aria-label": _vm.$t(
                            "edit_floor_plan_name_aria_label"
                          ),
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          autofocus: "",
                        },
                        on: {
                          keydown: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.saveNameEdit.apply(null, arguments)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape",
                                ])
                              ) {
                                return null
                              }
                              return _vm.cancelNameEdit.apply(null, arguments)
                            },
                          ],
                        },
                        model: {
                          value: _vm.editingName,
                          callback: function ($$v) {
                            _vm.editingName = $$v
                          },
                          expression: "editingName",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-col", { attrs: { cols: "auto" } }, [
                !_vm.isEditingName
                  ? _c(
                      "span",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              "aria-label": _vm.$t("edit_floor_plan_name"),
                            },
                            on: { click: _vm.startNameEdit },
                          },
                          [_c("v-icon", [_vm._v("mdi-pencil")])],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEditingName
                  ? _c(
                      "span",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              color: "primary",
                              "aria-label": _vm.$t("save_floor_plan_name"),
                            },
                            on: { click: _vm.saveNameEdit },
                          },
                          [_c("v-icon", [_vm._v("mdi-check")])],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        small: "",
                        "aria-label": _vm.$t("add_floor_plan"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("add")
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-plus")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.currentFloorPlan
                ? _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            small: "",
                            loading: _vm.deleting,
                            disabled: _vm.deleting,
                            "aria-label": _vm.$t("delete_floor_plan"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("delete")
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-delete")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.hasUnsavedChanges && !_vm.saving
                ? _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "mb-0 pa-1",
                          attrs: { type: "warning", dense: "", text: "" },
                        },
                        [
                          _c("span", { staticClass: "text-caption" }, [
                            _vm._v(_vm._s(_vm.$t("unsaved_changes"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.saving
                ? _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "mb-0 pa-1",
                          attrs: { type: "info", dense: "", text: "" },
                        },
                        [
                          _c("span", { staticClass: "text-caption" }, [
                            _vm._v(_vm._s(_vm.$t("saving"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasUnsavedChanges
                ? _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            color: "primary",
                            small: "",
                            loading: _vm.saving,
                            disabled: _vm.saving,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("save")
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { "x-small": "", left: "" } }, [
                            _vm._v("mdi-content-save"),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("save")) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("cancel")
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { "x-small": "", left: "" } }, [
                            _vm._v("mdi-close"),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("cancel")) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "mt-2", attrs: { align: "center" } },
            [
              _c("v-col", { attrs: { cols: "auto" } }, [
                _c("span", { staticClass: "text-body-2 font-weight-medium" }, [
                  _vm._v(_vm._s(_vm.$t("month_label")) + ":"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ml-2 d-inline-block compact-select",
                    staticStyle: { width: "90px" },
                  },
                  [
                    _c("month-field", {
                      attrs: {
                        value: _vm.selectedMonth,
                        dense: "",
                        outlined: "",
                        "hide-details": "",
                        "data-testid": "month-selector",
                      },
                      on: {
                        input: function (value) {
                          return _vm.$emit("month-change", value)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "span",
                    { staticClass: "text-body-2 font-weight-medium" },
                    [_vm._v(_vm._s(_vm.$t("insect_filter_label")) + ":")]
                  ),
                  _vm._v(" "),
                  _c("insect-filter-select", {
                    staticClass: "ml-2 d-inline-block compact-select",
                    attrs: {
                      value: _vm.insectFilter,
                      "data-testid": "insect-filter-select",
                    },
                    on: {
                      input: function (value) {
                        return _vm.$emit("insect-filter-change", value)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "span",
                    { staticClass: "text-body-2 font-weight-medium" },
                    [_vm._v(_vm._s(_vm.$t("display_mode_label")) + ":")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "", "max-width": "300" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ml-1",
                                      staticStyle: {
                                        "vertical-align": "text-bottom",
                                      },
                                      attrs: {
                                        small: "",
                                        "data-testid": "data-basis-info-icon",
                                        "aria-label":
                                          _vm.$t("data_basis_tooltip"),
                                      },
                                    },
                                    "v-icon",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n              mdi-information-outline\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("data_basis_tooltip"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "ml-2 d-inline-block compact-select",
                    staticStyle: { width: "200px" },
                    attrs: {
                      value: _vm.displayMode,
                      items: _vm.displayModeOptions,
                      dense: "",
                      outlined: "",
                      "hide-details": "",
                      "data-testid": "display-mode-select",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("display-mode-change", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.currentFloorPlan
                ? _c(
                    "v-col",
                    {
                      staticClass: "d-flex align-center",
                      attrs: { cols: "auto" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            small: "",
                            loading: _vm.exporting,
                            disabled: _vm.exporting,
                            "aria-label": _vm.$t("download_floor_plan"),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("download")
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-download")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.loadingEvents || _vm.exporting
        ? _c("v-progress-linear", {
            staticClass: "toolbar-progress",
            attrs: { indeterminate: "", color: "primary", height: "2" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }